import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef, useState } from 'react';
import MaskedInput from 'react-maskedinput';
import { Typography } from '../../components/Typography';
import { Icon } from '../../components/Icon';
import { useTheme } from 'react-jss';
import { useStyles } from './styles';
import clsx from 'clsx';
import { Icons } from '../../types/icons';
var TextInputTypes = {
  TEXT: 'text',
  PASSWORD: 'password',
  EMAIL: 'email',
  TEL: 'tel',
  NUMBER: 'number',
  DATE: 'date',
  FILE: 'file',
  TIME: 'time',
  URL: 'url'
};
var TextInput = forwardRef(function (_a, ref) {
  var _clsx;

  var _a$autofocus = _a.autofocus,
      autofocus = _a$autofocus === void 0 ? false : _a$autofocus,
      _a$canPaste = _a.canPaste,
      canPaste = _a$canPaste === void 0 ? true : _a$canPaste,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$errorOnTop = _a.errorOnTop,
      errorOnTop = _a$errorOnTop === void 0 ? false : _a$errorOnTop,
      _a$hasError = _a.hasError,
      hasError = _a$hasError === void 0 ? false : _a$hasError,
      icon = _a.icon,
      inputHeight = _a.inputHeight,
      _a$mask = _a.mask,
      mask = _a$mask === void 0 ? '' : _a$mask,
      maxLength = _a.maxLength,
      _a$messageError = _a.messageError,
      messageError = _a$messageError === void 0 ? '' : _a$messageError,
      _a$name = _a.name,
      name = _a$name === void 0 ? '' : _a$name,
      onClickIcon = _a.onClickIcon,
      onFocusOut = _a.onFocusOut,
      onInputChange = _a.onInputChange,
      onKeyDown = _a.onKeyDown,
      onKeyPress = _a.onKeyPress,
      _a$placeholder = _a.placeholder,
      placeholder = _a$placeholder === void 0 ? '' : _a$placeholder,
      _a$readOnly = _a.readOnly,
      readOnly = _a$readOnly === void 0 ? false : _a$readOnly,
      _a$required = _a.required,
      required = _a$required === void 0 ? false : _a$required,
      size = _a.size,
      _a$type = _a.type,
      type = _a$type === void 0 ? TextInputTypes.TEXT : _a$type,
      value = _a.value,
      inputProps = __rest(_a, ["autofocus", "canPaste", "disabled", "errorOnTop", "hasError", "icon", "inputHeight", "mask", "maxLength", "messageError", "name", "onClickIcon", "onFocusOut", "onInputChange", "onKeyDown", "onKeyPress", "placeholder", "readOnly", "required", "size", "type", "value"]);

  var InputTag = mask ? MaskedInput : 'input';
  var isPassword = type === TextInputTypes.PASSWORD;
  var theme = useTheme();
  var styles = useStyles({
    theme: theme
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showPassword = _useState2[0],
      setShowPassword = _useState2[1];

  var inputStyle = clsx((_clsx = {}, _defineProperty(_clsx, styles.input, true), _defineProperty(_clsx, styles.inputError, hasError), _defineProperty(_clsx, styles.inputPassword, isPassword && !showPassword), _defineProperty(_clsx, styles.inputIcon, !!icon || isPassword), _clsx));

  var getKeyboardType = function getKeyboardType() {
    if (isPassword) return showPassword ? TextInputTypes.TEXT : TextInputTypes.PASSWORD; // Somente números com base na máscara informada (ex: mask=111.111.11)
    // Nota: type TEL ao invés de NUMBER devido a limitação do react-maskedinput

    if (mask && mask.includes('1') && !mask.includes('a') && !mask.includes('A') && !mask.includes('*') && !mask.includes('#')) return TextInputTypes.TEL;
    return type;
  };

  var getIconName = function getIconName() {
    if (isPassword) {
      return showPassword ? Icons.MicrophoneOn : Icons.MicrophoneOff;
    } else {
      return icon;
    }
  };

  var handleFocus = function handleFocus() {
    if (ref && typeof ref !== 'function') {
      ref.current.focus();
    }
  };

  var onShowPassword = function onShowPassword() {
    setShowPassword(!showPassword);
    handleFocus();
  };

  var _onPaste = function onPaste(e) {
    if (!canPaste) e.preventDefault();
    return canPaste;
  };

  return React.createElement("div", {
    className: styles.container
  }, hasError && errorOnTop && React.createElement(Typography, {
    variant: "content3",
    color: "danger",
    customClassName: styles.topError
  }, messageError), React.createElement("div", {
    className: styles.content
  }, React.createElement(InputTag, Object.assign({}, inputProps, {
    ref: ref,
    autoComplete: "off",
    autoFocus: autofocus,
    className: inputStyle,
    disabled: disabled,
    id: name,
    mask: mask ? mask : '',
    maxLength: maxLength,
    name: name,
    onBlur: onFocusOut,
    onChange: onInputChange,
    onDrop: function onDrop(e) {
      return _onPaste(e);
    },
    onDropCapture: function onDropCapture(e) {
      return _onPaste(e);
    },
    onKeyDown: onKeyDown,
    onKeyPress: onKeyPress,
    onPaste: function onPaste(e) {
      return _onPaste(e);
    },
    onPasteCapture: function onPasteCapture(e) {
      return _onPaste(e);
    },
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    size: size,
    style: inputHeight && {
      'height': inputHeight
    },
    type: getKeyboardType(),
    value: value
  })), !!icon || isPassword ? React.createElement(Icon, {
    height: "24",
    width: "24",
    name: getIconName(),
    color: theme.palette.primary.regular,
    customClassName: styles.iconButton,
    onClick: isPassword ? onShowPassword : onClickIcon
  }) : null), hasError && !errorOnTop && React.createElement(Typography, {
    variant: "content3",
    color: "danger",
    customClassName: styles.bottomError
  }, messageError));
});
export { TextInput, TextInputTypes };